import type {
	SenderUpdateInput,
	batchCreateSendersInput,
	createSenderGroupInput,
	createSenderInput,
	deleteMultipleSendersInput,
	deleteSenderGroupInput,
	getOneSenderInput,
	getSenderGroupInput,
	getSenderGroupsInput,
	getSenderHistoryInput,
	getSenderTransferListInput,
	getSenderTransferRecordsInput,
	getSendersFacetsInput,
	getSendersInput,
	requestForBatchReloginInput,
	requestForReloginInput,
	stopResumeMultipleSendersInput,
	updateSenderGroupInput,
	updateSenderInfoInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetSenders: getSendersInput;
	useCreateSingleSender: createSenderInput;
	useCreateBatchSenders: batchCreateSendersInput;
	useGetSenderById: getOneSenderInput;
	useGetSenderStatusHistory: getSenderHistoryInput;
	useGetSenderTransferRecord: getSenderTransferRecordsInput;
	useGetSenderTransferList: getSenderTransferListInput;
	useDeleteMultipleSenders: deleteMultipleSendersInput;
	useStopResumeMultipleSenders: stopResumeMultipleSendersInput;
	useUpdateSender: updateSenderInfoInput;
	useAssignSenderGroup: {
		senderIds: string[];
		senderGroupId: SenderUpdateInput["sender_group_id"];
	};
	useBatchUpdateSenderPriority: undefined;
	useGetSendersFacets: getSendersFacetsInput;
	useReloginForOneSender: requestForReloginInput;
	useReloginMultipleSenders: requestForBatchReloginInput;
	useGetSenderGroups: getSenderGroupsInput;
	useGetSenderGroup: getSenderGroupInput;
	useCreateSenderGroup: createSenderGroupInput;
	useUpdateSenderGroup: updateSenderGroupInput;
	useDeleteSenderGroup: deleteSenderGroupInput;
	useDeleteSenderGroups: undefined;
}

const SENDER_SERVICE_KEYS = createReactQueryKeys<Keys>("sender", [
	"useGetSenders",
	"useCreateSingleSender",
	"useCreateBatchSenders",
	"useGetSenderById",
	"useGetSenderStatusHistory",
	"useGetSenderTransferList",
	"useGetSenderTransferRecord",
	"useDeleteMultipleSenders",
	"useStopResumeMultipleSenders",
	"useUpdateSender",
	"useAssignSenderGroup",
	"useBatchUpdateSenderPriority",
	"useGetSendersFacets",
	"useReloginForOneSender",
	"useReloginMultipleSenders",
	"useGetSenderGroups",
	"useGetSenderGroup",
	"useCreateSenderGroup",
	"useUpdateSenderGroup",
	"useDeleteSenderGroup",
	"useDeleteSenderGroups",
]);

export { SENDER_SERVICE_KEYS };
